import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["afterIcon", "allowIconLeading", "beforeIcon", "children", "color", "disabled", "fontSize", "fontWeight", "inline", "loading", "onClick", "spacingSize", "textDecoration", "type"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { clsx } from 'clsx';
import { useForkRef } from '@cian/react-utils';
import { useKeyboardEventHandler } from './internal/hooks';
import * as styles from './styles.module.css';
import { Spinner } from '../../../loader';
import { getTypographyComponent, InlineIconText, useLeadingIcon } from '../../internal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const ActionLinkComponent = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      afterIcon,
      allowIconLeading = false,
      beforeIcon,
      children,
      color = 'default',
      disabled = false,
      fontSize = 'M',
      fontWeight = 'normal',
      inline = false,
      loading = false,
      onClick,
      spacingSize = 'XS',
      textDecoration = 'none',
      type = 'button'
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const className = clsx(styles['action-link'], styles["spacing-size-".concat(spacingSize)], styles["font-size-".concat(fontSize)], styles["text-decoration-".concat(textDecoration)], color === 'default' ? styles['default-color'] : styles[color], {
    [styles['loading']]: loading,
    [styles['disabled']]: disabled,
    [styles['no-content']]: !children,
    [styles['inline']]: inline
  });
  const {
    linkRef,
    beforeIconRef
  } = useLeadingIcon({
    allowIconLeading,
    beforeIcon,
    inline
  });
  const handleRef = useForkRef(ref, linkRef);
  const TypographyComponent = getTypographyComponent(fontSize, fontWeight);
  const beforeIconElement = beforeIcon && /*#__PURE__*/_jsx("span", {
    ref: beforeIconRef,
    className: styles['before-icon'],
    children: beforeIcon
  });
  const afterIconElement = afterIcon && /*#__PURE__*/_jsx("span", {
    className: styles['after-icon'],
    children: afterIcon
  });
  const content = /*#__PURE__*/_jsxs(_Fragment, {
    children: [loading && /*#__PURE__*/_jsx("div", {
      className: styles['spinner'],
      children: /*#__PURE__*/_jsx(Spinner, {
        size: 16,
        color: "current_color"
      })
    }), children ? /*#__PURE__*/_jsx(TypographyComponent, {
      as: "span",
      color: "current_color",
      display: "inline",
      children: /*#__PURE__*/_jsx(InlineIconText, {
        beforeIcon: beforeIconElement,
        afterIcon: afterIconElement,
        textClassName: styles['text'],
        children: children
      })
    }) : beforeIcon]
  });
  const handleSpanKeyDown = useKeyboardEventHandler(onClick);
  const baseProps = _objectSpread({
    ref: handleRef,
    className,
    onClick
  }, rest);
  if (inline) {
    return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
      role: "button",
      tabIndex: 0,
      onKeyDown: handleSpanKeyDown
    }, baseProps), {}, {
      children: content
    }));
  }
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
    type: type
  }, baseProps), {}, {
    children: content
  }));
});
ActionLinkComponent.displayName = 'ActionLink';

/**
 * Компонент кнопки-ссылки для действий внутри одной страницы, не должен затрагивать url.
 *
 * [Ссылка на макет](https://www.figma.com/design/cNuS3sj8bvgbNtwim79jYZ/%F0%9F%8C%90-Link)
 */
export const ActionLink = /*#__PURE__*/React.memo(ActionLinkComponent);